import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import HeaderNav from './HeaderNav'
import HeaderStatistics from './HeaderStatistics'

function Header({
  image,
  altText,
  modelsCount,
  designersCount,
  scrollOffset,
}) {
  const additionalOffset = 52

  const sections = [
    { id: 'about-header-section', title: 'About' },
    { id: 'about-about-section', title: 'Story' },
    { id: 'about-investors-section', title: 'Investors' },
    { id: 'about-press-section', title: 'Press' },
  ]

  return (
    <section
      id="about-header-section"
      className="header header-with-nav header--no-bottom-spacing header--grey"
    >
      <HeaderNav sections={sections} offset={scrollOffset} additionalOffset={additionalOffset} />
      <div className="container-fixed">
        <div className="row align-items-center header-with-nav__content">
          <div className="col-12 col-md-6 col-lg-5">
            <h1 className="heading-32 info-section__heading section-heading">
              The World’s Preferred Source for
              <strong> 3D content</strong>
            </h1>
            <p className="heading-20 info-section__description">
              CGTrader is the world’s largest source for licensable stock and custom 3D models. The self-service
              <strong> CGTrader Marketplace </strong>
              showcases
              {` ${numeral(modelsCount).format('0,0')} `}
              3D models and includes a managed community of
              {` ${numeral(designersCount).format('0.00 a')}`}
              illion users.
              <strong> CGTrader Enterprise 3D Modeling </strong>
              allows enterprise customers and online retailers to transform their 2D product images into photorealistic
              3D models for Augmented Reality and other 3D customer experiences.
            </p>
          </div>
          <div className="col-12 col-md-6 offset-lg-1">
            <div className="header__viewer">
              <img src={image} alt={altText} className="info-section__image--full-width" />
            </div>
          </div>
        </div>
      </div>
      <HeaderStatistics
        modelsCount={modelsCount}
        designersCount={designersCount}
      />
    </section>
  )
}

Header.propTypes = {
  image: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  modelsCount: PropTypes.number.isRequired,
  designersCount: PropTypes.number.isRequired,
  scrollOffset: PropTypes.number.isRequired,
}

export default Header
